import script from "./addHours.vue?vue&type=script&lang=js"
export * from "./addHours.vue?vue&type=script&lang=js"

import "./addHours.vue?vue&type=style&index=0&id=87ac6912&lang=css"
import "./addHours.vue?vue&type=style&index=1&id=87ac6912&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ac6912"]])

export default __exports__